<template>
  <v-card class="py-3" elevation="5">
    <title-card text="Se miden 7 Ejes e Igualdad"/>
    <v-skeleton-loader
      :loading="!axes"
      class="mx-auto"
      type="date-picker-days@2"
      height="535"
    >
      <v-row>
        <v-col
          cols="6"
          v-for="(axis, idx) in axes"
          class="py-0"
          :order="axis.slug =='igualdad' ? 2 : 1"
        >
          <v-row class="mx-0">
            <v-col 
              cols="12"
              class="pb-0"
              :align="(idx-(idx>1?1:0))%2 ? 'end': 'start'"
            >
              <router-link
                :to="`/eje/${axis.slug}`"
                style="text-decoration: none;"
              >
                <span 
                  :class="{'subtitle-2': $vuetify.breakpoint.lgAndUp,
                    'pointer': true}"
                  :style="{'color': axis.color}"
                >
                  {{axis.nombre_corto}}
                </span>
              </router-link>
            </v-col>
            <v-col 
              cols="7" 
              :order="(idx-(idx>1?1:0))%2 ? 2 : 1" 
              align="center" 
              class="px-0 pt-1"
            >
              <router-link :to="`/eje/${axis.slug}`">
                <img 
                  :src="axis.logo"
                  :alt="axis.nombre_corto || axis.nombre" 
                  max-width="60"
                  class="pointer"
                  height="60"
                >
              </router-link>
            </v-col>
            <v-col
              cols="5"
              :order="(idx-(idx>1?1:0))%2 ? 1 : 2"
              align="center"
              justify="center"
              class="pt-0"
            >
              <v-badge
                v-if="axis.slug !='igualdad'"
                color="white"
                bottom
                overlap
                :left="(idx-(idx>1?1:0))%2 ? true : false"
                offset-y="12"
                offset-x="28"
              >
                <template v-slot:badge>
                  <b 
                    :style="{'color': axis.color}"
                    style="line-height: 1rem"
                    class="title"
                  >
                    {{format_perc(axis.mean_value)}}
                  </b>
                </template>
                <BubbleChart 
                  :ies="ies || ies_data"
                  clickable
                  :col="axis"
                  :axis="axis"
                  :value="axis.mean_value"
                  @open_intercard="open_dialog_ic($event)"
                  :mean="'X'"
                />
              </v-badge>            
              <v-tooltip top color="orange" v-else>
                <template v-slot:activator="{ on }">
                  <router-link
                    to="/eje/igualdad"
                    style="text-decoration: none;"
                  >
                    <v-row 
                      align="center"
                      justify="center"
                      class="mt-3" 
                      :href="'/ejes/igualdad'" v-on="on">
                      <v-icon x-large color="orange">bar_chart</v-icon>
                      <br>
                      <span class="body-2 mt-1 orange--text">Ver datos</span>
                    </v-row>
                  </router-link>
                </template>
                <span>Abrir en una nueva vista</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-skeleton-loader>
    <inter-card
      :dialog_update.sync="want_open" 
      :content_data="data_dialog"
      :is_dialog="2"
      :ies="ies"
    />
  </v-card>
</template>


<script>

import { mapState, } from "vuex";
import homeMixin from "../homeMixin";
import BubbleChart from "../charts/BubbleChart";
import * as d3 from 'd3';
import TitleCard from "../common/TitleCard";
import InterCard from "../views/InterCard";

export default {
  name: 'AxesChart',
  components: {
    BubbleChart,
    TitleCard,
    InterCard,
  },
  mixins: [homeMixin],
  props:{
    ies:{
      type: Object,
      required: false,
    },
  },
  data(){
    return {
    }
  },
  computed:{
    ...mapState({
      ejes: state => state.ejes,      
      axes_means: state => state.axes_means,
    }),
    axes(){
      return this.ies
        ? this.ejes.map(eje=>( {...eje, ...{mean_value: this.calcAxis(eje)}}))
        : this.axes_means
          ? this.ejes.map(eje=>
            ({...eje, ...{mean_value: this.axes_means[String(eje.id)]}}))
          : this.ejes
    },
    ies_data(){
      return {id: 0, siglas: `${this.ies ? this.ies.siglas : 'TODAS LAS IES'}`,
          nombre:'Promedio de todas las IES'}
    }
  },
  methods: {
    calcAxis(axis){
      //console.log(this.ies)
      return d3.mean(this.ies.indicador_values.filter(ind=>ind.eje==axis.id),
        d=> d.valor)
    },
    toAxis(slug){
      this.$router.push(`/eje/${slug}`)
       //router.replace(`/dashboard/${page_demo.pid}/home`)
    },
  },
  mounted(){
    //console.log(this.axes_mean)
  }
}
</script>

<style lang="scss" scoped>
</style>